import { createFileRoute, Outlet, useParams } from '@tanstack/react-router'
import { AllergensWidget } from '@/widgets/allergens-widget'

export const Route = createFileRoute(
  '/_auth/applications/limitations/limitation/$limitationId/allergens'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { limitationId } = useParams({
    from: '/_auth/applications/limitations/limitation/$limitationId/allergens',
  })

  return (
    <>
      <AllergensWidget taskId={limitationId} basePath="applications" />
      <Outlet />
    </>
  )
}
